import { NgModule } from '@angular/core';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreMenusModule } from '@xbaht/ui/core/components/core-menus/core-menus.module';

import { HorizontalMenuComponent } from './horizontal-menu.component';

@NgModule({
  declarations: [HorizontalMenuComponent],
  imports: [CoreMenusModule, CoreCommonModule],
  exports: [HorizontalMenuComponent],
})
export class HorizontalMenuModule {}
